/* eslint-disable no-console */

export function handleError(error) {
  var result = {};
  if (!error.response) {
    result["serverError"] = {
      label: "Error: No response",
      message:
        "There was no response from the server.\n" +
        "Check your connection? Otherwise the server is probably down or " +
        "an error/bug isn't being handled correctly...\n\n" +
        "The error was:\n" +
        error
    };
    // Return as there is not more data to process =(
    return result;
  }
  // Handle 500 server errors
  if (error.response.status == 500) {
    result["serverError"] = {
      label: `Error ${error.response.status}: ${error.response.statusText}`,
      message: `Don't worry, it's us, not you. This error has been reported to the site admins who will work on fixing it ASAP.`
    };
  } else if (error.response.status == 404) {
    result["serverError"] = {
      label: `Error ${error.response.status}: ${error.response.statusText}`,
      message: `Sorry, we couldn't find the page at ${error.response.config.url}. This error has been reported to the site admins who will work on fixing it ASAP.`
    };
  } else {
    // Handle field errors
    for (let item in error.response.data) {
      // Manage specific cases to return all non-field errors as 'serverError'
      let message = (message = error.response.data[item]);
      if (Array.isArray(message)) {
        message = message.join(" ");
      }
      // ServerErrors have a label that shows the server error code (etc.)
      if (item == "non_field_errors" || item == "detail") {
        let label = `Error ${error.response.status}: ${error.response.statusText}`;
        let field = "serverError";
        result[field] = { label: label, message: message };
      } else {
        // It is a field error, so there's no label, just a message.
        let field = item;
        result[field] = message;
      }
    }
  }
  console.log(result);
  return result;
}
